/**
 * @file Component representing an insight.
 * @author Tom Verschoore de la Houssaije.
 */
import { ElementRef } from '@angular/core';
import { LocalStorageService } from '../../core/local-storage.service';
var scrollStepSize = 256;
/**
 * Class for representing an insight
 */
var InsightsComponent = /** @class */ (function () {
    /**
     * Constructs a InsightsComponent
     */
    function InsightsComponent(localStorageService) {
        this.localStorageService = localStorageService;
        /** Gets, sets display and scroll information of the insights.  */
        this.insightsElementData = {
            'width': -1,
            'scrollWidth': -1,
            'scrollLeft': -1,
            'scrollRight': -1,
            'clientWidth': -1
        };
        this.open = this.localStorageService.readProperty('local', 'insights-open', false, [true, false]);
    }
    /**
     * Check whether the left control must be visible or not
     * @returns True when the left control must be visible
     */
    InsightsComponent.prototype.showLeftControl = function () {
        // If insightsElement not exists, we don't want to show the control
        if (!this.insightsElement) {
            return false;
        }
        // If width is larger then scrollWidth hide the control
        if (this.insightsElementData.width > this.insightsElementData.scrollWidth) {
            return false;
        }
        // if there is no scroll space hide the control
        if (this.insightsElementData.scrollLeft < 3) {
            return false;
        }
        return true;
    };
    /**
     * Check whether the right control must be visible or not
     * @returns True when the right control must be visible
     */
    InsightsComponent.prototype.showRightControl = function () {
        // If insightsElement not exists, we don't want to show the control
        if (!this.insightsElement) {
            return false;
        }
        // If width is larger then scrollWidth hide the control
        if (this.insightsElementData.width > this.insightsElementData.scrollWidth) {
            return false;
        }
        // if there is no scroll space hide the control
        if (this.insightsElementData.scrollRight < 3) {
            return false;
        }
        return true;
    };
    /**
     * Move insights scroll one step size to the left
     */
    InsightsComponent.prototype.scrollLeft = function () {
        this.insightsElement.nativeElement.scrollLeft = this.insightsElement.nativeElement.scrollLeft - scrollStepSize;
    };
    /**
     * Move insights scroll one step size to the right
     */
    InsightsComponent.prototype.scrollRight = function () {
        this.insightsElement.nativeElement.scrollLeft = this.insightsElement.nativeElement.scrollLeft + scrollStepSize;
    };
    /**
     * On resize of the window update the insights data
     */
    InsightsComponent.prototype.onResize = function () {
        // Resize does effect the widths etc.
        this.updateInsightsData();
    };
    /**
     * On mouse enter update the insights data
     */
    InsightsComponent.prototype.onMouseEnter = function () {
        // During mouse over the width of the content *must* be available
        this.updateInsightsData();
    };
    /**
     * On scroll update the insights data
     */
    InsightsComponent.prototype.onScroll = function () {
        // On scroll update the scroll position
        this.insightsElementData.scrollLeft = this.insightsElement.nativeElement.scrollLeft;
        this.insightsElementData.scrollRight = this.insightsElementData.scrollWidth
            - (this.insightsElementData.scrollLeft
                + this.insightsElementData.clientWidth);
    };
    Object.defineProperty(InsightsComponent.prototype, "configuration", {
        /**
         * Get the configuration key
         */
        get: function () {
            return this._configuration;
        },
        /**
         * Sets the reference to configuration to use for initialization
         * @param config The configuration key
         */
        set: function (configuration) {
            this._configuration = configuration;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Check if insights component is open
     * @returns True if insights is open, otherwise false
     */
    InsightsComponent.prototype.isOpen = function () {
        return (this.open === true);
    };
    /**
     * Check if insights component is closed
     * @returns True if insights is closed, otherwise false
     */
    InsightsComponent.prototype.isClosed = function () {
        return (this.open === false);
    };
    /**
     * Set the insights component open
     */
    InsightsComponent.prototype.setOpen = function () {
        // Open insights
        this.open = this.localStorageService.updateProperty('local', 'insights-open', true, [true, false]);
    };
    /**
     * Set the insights component open
     */
    InsightsComponent.prototype.setClose = function () {
        // Close insights
        this.open = this.localStorageService.updateProperty('local', 'insights-open', false, [true, false]);
    };
    /**
     * Toggle between opening and closing the insights component
     */
    InsightsComponent.prototype.toggle = function () {
        if (this.isOpen()) {
            this.setClose();
        }
        else {
            this.setOpen();
        }
    };
    /**
     * Update the insights data
     */
    InsightsComponent.prototype.updateInsightsData = function () {
        if (!this.insightsElement || !this.insightsElement.nativeElement) { // Fix for the error described in the comments of #1712
            return;
        }
        // We use this data strategy to force Angular to update the template
        this.insightsElementData.width = this.insightsElement.nativeElement.getBoundingClientRect().width;
        this.insightsElementData.scrollWidth = this.insightsElement.nativeElement.scrollWidth;
        this.insightsElementData.clientWidth = this.insightsElement.nativeElement.clientWidth;
        this.insightsElementData.scrollLeft = this.insightsElement.nativeElement.scrollLeft;
        this.insightsElementData.scrollRight = this.insightsElementData.scrollWidth
            - (this.insightsElementData.scrollLeft
                + this.insightsElementData.clientWidth);
    };
    return InsightsComponent;
}());
export { InsightsComponent };
